import { useState, type ReactNode } from 'react';

/**
 * Un bloc de formulaire REPLIE par defaut (2026-10-13) : la ligne de
 * titre porte un resume de ce qui est saisi, et un clic deplie le
 * contenu. La fiche adherent en empile plusieurs — statut associatif,
 * droit a l'image, handicap — et seul celui qu'on vient modifier a
 * besoin d'etre ouvert.
 */
export function BlocRepliable({
  titre,
  resume,
  ouvertParDefaut = false,
  children,
}: {
  titre: string;
  /** Ce que la ligne de titre dit quand le bloc est replie. */
  resume: ReactNode;
  ouvertParDefaut?: boolean;
  children: ReactNode;
}) {
  const [ouvert, setOuvert] = useState(ouvertParDefaut);
  return (
    <div className="rounded-md border border-encre-200 p-3">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 text-left"
        onClick={() => setOuvert(!ouvert)}
        aria-expanded={ouvert}
      >
        <span className="etiquette !mb-0">{titre}</span>
        <span className="flex min-w-0 items-center gap-2 text-sm text-encre-600">
          <span className="truncate">{resume}</span>
          <span aria-hidden className="text-xs text-encre-400">
            {ouvert ? '▾' : '▸'}
          </span>
        </span>
      </button>
      {ouvert && <div className="mt-2">{children}</div>}
    </div>
  );
}
